// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 638) return "css/app_css-0390442f.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"678":"44c0b40a","942":"feff6461"}[chunkId] + ".css";
};